import { Component, OnInit } from '@angular/core';
import { ActivatedRouteSnapshot, NavigationEnd, Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  isMenuOpen = false;
  constructor(private router: Router, private route: ActivatedRoute) { }

  ngOnInit(): void {
    console.log(this.route.url); 
  }
  varios(item) {
    console.log(item)
    if (item == "directorio") {
      let dato = {
        id: 'directorio'
      }
      this.router.navigate(['/varios'], { queryParams: dato });
    }
  
  
  }

  toggleMenu(): void {
    // Implementar lógica del menú móvil aquí
    console.log('Toggle menu');
    this.isMenuOpen = !this.isMenuOpen;
  }

  irATramites() {
    this.router.navigate(['/inicio'], { fragment: 'tramites-comunes2' }).then(() => {
      setTimeout(() => {
        const element = document.getElementById('tramites-comunes2');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 500); // ⬆️ Aumentar a 500ms o más
    });
  }

}
